import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { NavLink, withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import ReactSVG from 'react-svg';

@withTranslation()
@withRouter
class Tab extends React.Component {
	
	constructor (props) {
		super(props);
		
		this.onTabClick = this.onTabClick.bind(this);
	}
	
	onTabClick (e) {
		if (this.props.onSelect) {
			e.preventDefault();
			this.props.onSelect(this.props.val);
		}
		if (this.props.onClick) this.props.onClick(this.props.val);
	};
	
	render () {
		const { val, history, counter, getPath, t, classPropName, name, icon, isNextActive } = this.props;
		const aPath = history.location.pathname.split('/');
		aPath.pop();
		aPath.push(val);
		const path = getPath ? getPath() : aPath.join('/');

		const title = name || t(`tabs.${val}`);

		return (
			<NavLink
                exact
                to={path}
                className={cx("tab-item", classPropName, {
                    "is-next-active": isNextActive,
                })}
                onClick={this.onTabClick}
                title={title}
            >
                <div className='tab-item-content'>
					<div className={cx("tab-svg-wrapper", { 'with-counter': counter})} >
						{icon && <ReactSVG svgClassName="tab-svg" src={`/data/svg/${icon}.svg`} />}
						{counter}
					</div>
					<span>{title}</span>
				</div>
			</NavLink>
			// <div className={cx("tab-item", { active: isActive })} key={tab} onClick={this.onTabClick}>
			// 	{icon && <ReactSVG className="tab-svg-wrapper" svgClassName="tab-svg" src={`/data/svg/${icon}.svg`} />}
			// 	{name || t(`tabs.${val}`).toUpperCase()} {counter}
			// </div>
		);
	}
}

Tab.propTypes = {
	val: PropTypes.string.isRequired,
	card: PropTypes.object,
	role: PropTypes.object,
	onClick: PropTypes.func,
};

export default Tab;
